import { render, staticRenderFns } from "./simple_editor.vue?vue&type=template&id=64f6f222&"
import script from "./simple_editor.vue?vue&type=script&lang=js&"
export * from "./simple_editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports